import { render, staticRenderFns } from "./FastOrdersTableAdmin.vue?vue&type=template&id=16a4a39b&scoped=true"
import script from "./FastOrdersTableAdmin.vue?vue&type=script&lang=js"
export * from "./FastOrdersTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4a39b",
  null
  
)

export default component.exports